import React from 'react'
import styled from 'styled-components'
import {
  colors,
  spacing,
  mediaQuery,
  typographyMixin,
  heading,
  fontWeight,
  body,
} from 'src/constants/marketing-ds'
import { REASON_CARDS } from '../data/cards'
import ReasonCard from './ReasonCard'

const DemandsSection = () => {
  return (
    <Section id="facts">
      <Container>
        <Header>
          <Title>We Are Fighting to Keep Your Bill Low</Title>
          <Subtitle>
            NBCU has had repeated public disputes with other distributors and is now using the same
            tactics against Fubo — weaponizing their sports content to force bad deals on you. This
            isn't just about price — it's about fair play.
          </Subtitle>
        </Header>
        <CardsGrid>
          {REASON_CARDS.map((card) => (
            <ReasonCard key={card.id} card={card} />
          ))}
        </CardsGrid>
      </Container>
    </Section>
  )
}

export default DemandsSection

const Section = styled.section`
  padding: ${spacing.xxl} ${spacing.sm};
  background-color: rgb(15 23 42);
  color: ${colors.white};
  scroll-margin-top: 80px;
  ${mediaQuery.tablet} {
    padding: ${spacing.xxxl} ${spacing.md};
  }
`

const Container = styled.div`
  max-width: 1152px;
  margin: 0 auto;
`

const Header = styled.div`
  text-align: center;
  margin-bottom: ${spacing.lg};

  ${mediaQuery.tablet} {
    margin-bottom: ${spacing.xxl};
  }
`

const Title = styled.h2`
  ${typographyMixin(heading.lg, { fontWeight: fontWeight.bold })}
  margin-bottom: ${spacing.md};
  color: ${colors.white};
  text-align: left;

  ${mediaQuery.tablet} {
    ${typographyMixin(heading.xl, { fontWeight: fontWeight.bold })}
    text-align: center;
  }
  ${mediaQuery.desktop} {
    ${typographyMixin(heading.xxl, { fontWeight: fontWeight.bold })}
  }
`

const Subtitle = styled.p`
  color: ${colors.white};
  max-width: 800px;
  margin: 0 auto;
  text-align: left;

  ${typographyMixin(body.sm, { fontWeight: fontWeight.normal })}
  ${mediaQuery.tablet} {
    text-align: center;

    ${typographyMixin(body.md, { fontWeight: fontWeight.normal })}
  }
  ${mediaQuery.desktop} {
    ${typographyMixin(body.lg, { fontWeight: fontWeight.normal })}
  }
  line-height: 1.6;
`

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.md};

  ${mediaQuery.tablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: ${spacing.sm};
  }
  ${mediaQuery.desktop} {
    gap: ${spacing.lg};
  }
`
